import { EachConditionDataKeys as CabinEachKeys } from "atoms/Rtool/cabinAtoms";
import { EachConditionDataKeys as MtgEachKeys } from "atoms/Rtool/mtgAtoms";

export const DRIVE_MODE_IDS = [
    "wot",
    "01g",
    "02g",
    "dec",
] as const;

export const PHENOMENON_IDS = [
    "gn_pos",
    "gn_fd",
    "mn_vib_24th",
    "mn_vib_48th",
    "mn_vib_72th",
    "mn_vib_96th",
    "mn_aco_24th",
    "mn_aco_48th",
    "mn_aco_72th",
    "mn_aco_96th",
] as const;

export const DATASET_IDS = [
    "background_noise_target",
    "deltaL_target",
    "insu_ctr_corr",
    "mtg_insu",
    "ntf",
    "cabin_noise_meas",
    "mtg_vib",
    "noise_contrib",
] as const;

// 条件単位の copy API は common データを受け付けないため、Excel 登録用の全候補とは分ける。
export const CONDITION_COPY_DATASET_IDS = DATASET_IDS.filter((id) => id !== "ntf");

export const CABIN_NOISE_EACH_IDS: readonly CabinEachKeys[] = [
    "cabin_noise_pred_background",
    "contribution",
    "ntf",
    "mtg_insu",
    "mtg_vib_ctr",
    "mtg_vib"
];

export const MTG_VIB_EACH_IDS: readonly MtgEachKeys[] = [
    "cabin_noise_target",
    "contribution",
    "ntf",
    "mtg_insu",
    "mtg_vib_ctr_target",
    "mtg_vib_target",
] as const;
